/* @jsx h */
import { defineComponent, h } from "vue";
import { QROrderingSlide } from "../Landing/components";

export const StaffReservationsPage = defineComponent({
  name: "StaffReservations",
  setup() {
    return () => {
      return (
        <div class="flex flex-1 justify-center items-center container mx-auto">
          <QROrderingSlide />
        </div>
      );
    };
  },
});
